import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/delay_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-12eaac7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-header" }
const _hoisted_2 = {
  key: 0,
  class: "update-info"
}
const _hoisted_3 = {
  class: "batch-trade-btn",
  style: {"display":"none"}
}
const _hoisted_4 = {
  key: 0,
  class: "loading-wrap"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading-dot" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "table-wrapper table-wrapper--empty" }
const _hoisted_8 = { class: "position-table" }
const _hoisted_9 = { class: "col-idx" }
const _hoisted_10 = { class: "col-name-code" }
const _hoisted_11 = { class: "col-change" }
const _hoisted_12 = { class: "col-price" }
const _hoisted_13 = { class: "col-date" }
const _hoisted_14 = { class: "col-action" }
const _hoisted_15 = { class: "empty-wrap" }
const _hoisted_16 = {
  key: 2,
  class: "table-wrapper"
}
const _hoisted_17 = { class: "position-table" }
const _hoisted_18 = { class: "col-idx" }
const _hoisted_19 = { class: "col-name-code" }
const _hoisted_20 = { class: "col-change" }
const _hoisted_21 = { class: "col-price" }
const _hoisted_22 = { class: "col-date" }
const _hoisted_23 = { class: "col-action" }
const _hoisted_24 = ["onDblclick"]
const _hoisted_25 = { class: "col-idx" }
const _hoisted_26 = { class: "col-name-code" }
const _hoisted_27 = { class: "stock-name" }
const _hoisted_28 = { class: "stock-code-row" }
const _hoisted_29 = {
  key: 0,
  src: _imports_0,
  class: "delay-tag",
  alt: "延时"
}
const _hoisted_30 = { class: "symbol-text" }
const _hoisted_31 = { class: "col-date" }
const _hoisted_32 = { class: "col-action" }
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nodata = _resolveComponent("Nodata")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createElementBlock("div", {
    class: "position-panel",
    style: _normalizeStyle({
    '--pp-bg':          _ctx.panelVars.panelBg,
    '--pp-gap-bg':      _ctx.panelVars.gapBg,
    '--pp-border':      _ctx.panelVars.panelBorder,
    '--pp-header-bg':   _ctx.panelVars.headerBg,
    '--pp-header-text': _ctx.panelVars.headerText,
    '--pp-th-color':    _ctx.panelVars.thHeaderColor,
    '--pp-text':        _ctx.panelVars.textPrimary,
    '--pp-text-sub':    _ctx.panelVars.textSecondary,
    '--pp-row-hover':   _ctx.panelVars.rowHover,
    '--pp-btn-bg':      _ctx.panelVars.btnBg,
    '--pp-btn-text':    _ctx.panelVars.btnText,
    '--pp-spin-border': _ctx.panelVars.spinBorder,
    '--pp-spin-top':    _ctx.panelVars.spinTop,
  })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.tran('持仓分布')), 1),
      (_ctx.updateInfo)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.updateInfo), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", _hoisted_3, _toDisplayString(_ctx.tran('批量交易')), 1)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : (!_ctx.list.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.tran('序')), 1),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.tran('名称/代码')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.tran('涨跌')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.tran('现价')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.tran('调入时间')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.tran('操作')), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Nodata, {
                mode: "vertical",
                customdesc: _ctx.tran('暂无持仓数据'),
                pagetheme: _ctx.isDark ? 'dark' : 'light'
              }, null, 8, ["customdesc", "pagetheme"])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.tran('序')), 1),
                  _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.tran('名称/代码')), 1),
                  _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.tran('涨跌')), 1),
                  _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.tran('现价')), 1),
                  _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.tran('调入时间')), 1),
                  _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.tran('操作')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.symbol,
                    onDblclick: ($event: any) => (_ctx.goStockDetail(item))
                  }, [
                    _createElementVNode("td", _hoisted_25, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", _hoisted_26, [
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ])), [
                        [_directive_widthoverflowtitle, item.name]
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        (_ctx.isDelayed(item.market))
                          ? (_openBlock(), _createElementBlock("img", _hoisted_29))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          class: _normalizeClass(["market-label", _ctx.isHKMarket(item.market) ? 'label-hk' : 'label-us'])
                        }, _toDisplayString(_ctx.getMarketLabel(item.market)), 3),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(item.symbol), 1)
                      ])
                    ]),
                    _createElementVNode("td", {
                      class: _normalizeClass(["col-change", _ctx.getChangeClass(item.changeRate)])
                    }, _toDisplayString(_ctx.formatPct(item.changeRate)), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["col-price", _ctx.getChangeClass(item.changeRate)])
                    }, _toDisplayString(_ctx.formatPrice(item.price)), 3),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.formatDate(item.addTime)), 1),
                    _createElementVNode("td", _hoisted_32, [
                      _createElementVNode("button", {
                        class: "trade-btn",
                        onClick: _withModifiers(($event: any) => (_ctx.handleTrade(item)), ["stop"])
                      }, _toDisplayString(_ctx.tran('交易')), 9, _hoisted_33)
                    ])
                  ], 40, _hoisted_24))
                }), 128))
              ])
            ])
          ]))
  ], 4))
}